export const languages = ['UKR', 'EN']

export const languagesLesson = ['UA', 'EN']